
export default async ({ sparkyFramework: { getFrameworkVars, getState, getMicroAppVars } }) => {  
  
  const { private_site_origin } = getFrameworkVars();
  return async () => {

    return {
      actions: [
        {
          // This can be accessed only by route - see hidden attribute below
          key: 'netsec-co-pilot-conversation',
          path: '/netsec-copilot/conversation',
          title: 'NetSec CoPilot chat',
          avail: () => true,
          exact: false,
          //contentClassName: 'panwds-tw3 sparky-dark-only',
          component: () => import("../src/components/SingleConversationWrapper"),
          availFallbackRedirect: 'no-redirect',
          hidden: true, // Hide Nav item
        },
        { // sample URL
          //tse-assistant?caseNumber=02982902&tsgTenantId=1665278339&productType=ngfw&accountName=test&cdlTenantId=1977327585&reportTs=1714159341870
          key: 'tse-assistant',
          path: '/tse-assistant',
          title: 'TSE Assistant',
          icon: 'tse-assistant-icon',
          className: 'tse-assistant-page',
          noRBACheck: true,
          expandable: true,
          mergeNav: true,
          exact: false,
          avail: () => Boolean(private_site_origin),//control the show and hide of tse assistant only on AIOps for gcs env,
          callAvail: true,
          component: () => import("../src/components/TSEAssistantWrapper"),
          availFallbackRedirect: 'no-redirect',
        }
      ],
      exposes: {
        default: { 
          CopilotIconButton: () => import('./components/CopilotButtonIcon')
        },
        "scm_main_layout.content_right": {
          CopilotContextual: () => import('./pages/HostApp')
        }
      }
    };
  };
};
